import React, {useEffect, useState} from "react";

import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import Stack from '@mui/material/Stack';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';
import PersonIcon from '@mui/icons-material/Person';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import { Link } from "react-router-dom";

import { useUser } from "../UserContext";
import { IconButton } from "@mui/material";

import { UserTypes } from '../models/userTypes';
import { useAuth } from "../AuthContext";
import { closeKitchenByChef } from "../services/kitchenService";
import hubWebSocketService from "../services/hubWebSocketService";

export default function PageNavigator() {
  const { user, setUser } = useUser();
  const { auth, setAuth } = useAuth();

  function logoutCustomer() {
    logout();
  }

  function logout() {
    setUser(null);
    setAuth(null);
    hubWebSocketService.disconnect();
  }

  function logoutChef() {
    const chefId = user.chef.id;
    // close any open kitchen
    closeKitchenByChef(chefId, auth).then(() => {
      logout();
    }).catch((error) => {
      console.error('Error closing kitchen on logout for chefId: ' + chefId + ' - ' + error);
      alert('Looks like there was an issue closing your kitchen. Please try to close it manually from your dashboard.');

      // logout anyway
      logout();
    });
  }

  const authenticatedCustomerActions = [
    <Tooltip key={'customer-orders'} title={'My Orders'} placement="top-start" value="customer-orders">
      <Link to="/orders" ><IconButton><BookmarkBorderIcon /></IconButton></Link>
    </Tooltip>,
    <Tooltip key={'list'} title={'Search Page'} placement="top-start" value="list">
      <Link to="/list" ><IconButton><FormatAlignLeftIcon /></IconButton></Link>
    </Tooltip>,
    <Tooltip key={'profile'} title={'User Profile'} placement="top-start" value="profile">
      <Link to="/profile"><IconButton><PersonIcon /></IconButton> </Link>
    </Tooltip>,
    <Tooltip key={'signOut'} title={'Sign Out'} placement="top-start" value="signOut">
      <Link onClick={logoutCustomer} data-testid="customer-logout"><IconButton><LogoutIcon /></IconButton></Link>
    </Tooltip>,
  ];

  const authenticatedChefActions = [
    <Tooltip key={'kitchen-orders'} title={'My Orders'} placement="top-start" value="kitchen-orders">
      <Link to="/orders" ><IconButton><BookmarkBorderIcon /></IconButton></Link>
    </Tooltip>,
    <Tooltip key={'kitchen-dashboard'} title={'My Kitchen'} placement="top-start" value="kitchen-dashboard">
      <Link to="/dashboard" ><IconButton><RestaurantIcon /></IconButton></Link>
    </Tooltip>,
    <Tooltip key={'profile'} title={'User Profile'} placement="top-start" value="profile">
      <Link to="/profile"><IconButton><PersonIcon /></IconButton> </Link>
    </Tooltip>,
    <Tooltip key={'signOut'} title={'Sign Out'} placement="top-start" value="signOut">
      <Link onClick={logoutChef} data-testid="chef-logout"><IconButton><LogoutIcon /></IconButton></Link>
    </Tooltip>,
  ];

  if (!user) {
    return null;
  }

  return (
    <>
      {/* Mobile View: Fixed AppBar at bottom */}
      <AppBar 
        position="fixed" 
        sx={{ 
          display: { xs: 'block', md: 'none' },
          top: 'auto',
          bottom: 0,
          backgroundColor: 'white',
          boxShadow: 1
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-evenly', minHeight: 56, gap: 1 }}>
          {user.type && user.type.includes(UserTypes.CUSTOMER) ? authenticatedCustomerActions : authenticatedChefActions}
        </Toolbar>
      </AppBar>

      {/* Desktop/Tablet View: Standard Stack */}
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <Stack spacing={2} alignItems="center">
          <ToggleButtonGroup>
            {user.type && user.type.includes(UserTypes.CUSTOMER) ? authenticatedCustomerActions : authenticatedChefActions}
          </ToggleButtonGroup>
        </Stack>
      </Box>
    </>
  );
}
